import { z } from "zod";

import { config } from "./config";

const CompanyMeetingsParticipantSchema = z.object({
	id: z.string(),
	name: z.string(),
});

export const CompanyMeetingsFiltersSchema = z.object({
	participant: CompanyMeetingsParticipantSchema.optional(),
	dateRangeStart: z.date().optional(),
	dateRangeEnd: z.date().optional(),
	status: z.array(z.enum(config.statusOptions)).optional(),
});
export type CompanyMeetingsFilters = z.infer<typeof CompanyMeetingsFiltersSchema>;

export const CompanyMeetingsFilterFormSchema = z.object({
	participant: CompanyMeetingsParticipantSchema.nullable().optional(),
	dateRange: z.object({ from: z.date().optional(), to: z.date().optional() }).optional(),
	status: z.array(z.string()).default([]),
});
export type CompanyMeetingsFilterForm = z.infer<typeof CompanyMeetingsFilterFormSchema>;
